import { render, staticRenderFns } from "./AnnouncementView.vue?vue&type=template&id=3ef97293&"
import script from "./AnnouncementView.vue?vue&type=script&lang=js&"
export * from "./AnnouncementView.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementView.vue?vue&type=style&index=0&id=3ef97293&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports